import { restApi } from '../../api/restApiSlice';
import { cloudflareFlowApi } from './cloudflareFlowApi';

/** Mirrors the server's `SetupStartRefusal` (PRE-3394). */
export type CfSetupRefusal =
  | 'token_invalid'
  | 'manual_cleanup_required'
  | 'already_running'
  | 'not_startable'
  | 'beta_closed';

export type CfSetupResponse = {
  started: boolean;
  /** Why nothing was started. A refusal arrives as a 200, not an error. */
  refusal: CfSetupRefusal | null;
  status: string;
  setupAttemptNumber: number;
  failedStep: string | null;
};

const cloudflareSetupApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    startCfSetup: builder.mutation<CfSetupResponse, { domain: string }>({
      query: ({ domain }) => ({
        url: '/v3/cloudflare/setup',
        method: 'POST',
        params: { domain },
      }),
      /**
       * The server runs the whole install before it answers (tens of seconds)
       * and keeps answering the flow it started from until then — a failed one
       * says `polls: false`, so nothing would watch the new run move.
       */
      onQueryStarted: ({ domain }, { dispatch }) => {
        dispatch(
          cloudflareFlowApi.util.updateQueryData('getCfFlow', { domain }, (flow) => {
            Object.assign(flow, {
              screen: 'progress',
              status: 'preflight_running',
              polls: true,
              steps: {},
              errorDetail: null,
              rollbackOutcome: null,
            });
          }),
        );
      },
    }),
  }),
});

export { cloudflareSetupApi };
export const { useStartCfSetupMutation } = cloudflareSetupApi;
